<template>
	<el-dialog
			:close-on-click-modal="false"
			:visible.sync="finalVisible"
			title="移除订单"
			width="40%">
		<div>
			<!-- 确认移除提示 -->
			<el-alert
					class="remove-alert"
					show-icon
					title="确定移除此订单？"
					type="error"
			/>

			<!-- 移除理由输入框 -->
			<el-form :model="form" label-width="100px">
				<el-form-item :rules="[{ required: true, message: '请输入移除理由', trigger: 'blur' }]" label="移除理由">
					<el-input
							v-model="form.removeReason"
							placeholder="请输入移除订单的原因"
							rows="3"
							type="textarea"
					/>
				</el-form-item>
			</el-form>
		</div>
		<!-- 底部按钮 -->
		<div slot="footer" class="dialog-footer">
			<el-button @click="closeDialog">取消</el-button>
			<el-button :loading="loading" type="primary" @click="confirmRemoveOrder">确认</el-button>
		</div>
	</el-dialog>
</template>

<script>
// 引入 MiniModel
import mini from "@/api/mini";

export default {
	name: 'TaobaoOrderErrorRemoveDialog',
	props: {
		// 控制弹窗显示状态
		visible: {
			type: Boolean,
			required: true
		},
		// 接收要移除的订单ID
		id: {
			type: String,
			required: true
		}
	},
	computed: {
		// 计算属性，监听 visible 的变化
		finalVisible: {
			get() {
				return this.visible;
			},
			set(val) {
				this.$emit('update:visible', val);
			}
		}
	},
	data() {
		return {
			form: {
				removeReason: '' // 移除理由
			},
			loading: false,
			MiniModel: new mini() // 实例化 MiniModel
		};
	},
	methods: {
		closeDialog() {
			// 关闭弹窗并清空表单
			this.$emit('update:visible', false);
			this.form.removeReason = '';
		},
		async confirmRemoveOrder() {
			if (!this.form.removeReason) {
				this.$message.error('请输入移除理由');
				return;
			}

			this.loading = true;

			try {
				// 调用 MiniModel 的接口移除订单
				await this.MiniModel.taobaoOcrRemoveOrder({
					id: this.id,
					remark: this.form.removeReason
				});

				// 移除成功后触发外部事件
				this.$emit('remove-success', this.id);
				this.$message.success('订单移除成功');
				this.closeDialog();
			} catch (error) {
				this.$message.error(error.message || '移除订单失败');
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>

<style scoped>
.remove-alert {
	margin-bottom: 20px;
}

.dialog-footer {
	display: flex;
	justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/components/taobaoOrderErrorRemoveDialog.vue